import React from "react";
import PropTypes from "prop-types";
import { Dialog } from "@headlessui/react";

export default function ModalTitle(props) {
  return (
    <>
      <div className="sm:flex sm:items-start w-full">
        {props.titleIcon && (
          <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            {props.titleIcon}
          </div>
        )}
        <div className="mt-3 text-center sm:mt-0  sm:text-left w-full">
          <Dialog.Title
            as="h3"
            className="text-lg leading-6 font-medium text-gray-900"
          >
            {props.children}
          </Dialog.Title>
        </div>
      </div>
    </>
  );
}

ModalTitle.propTypes = {
  children: PropTypes.any.isRequired,
  titleIcon: PropTypes.any,
};
